import heatmap from 'heatmap.js'

import dataStore from './store'

const me = {
    dataStore,
    maxZoom : 5,
    zoomStep : 70,
    zoomStepMobile : 20,
};

const repositionImage = function() {

    $(document).find('.slider-for .image-type-slide').css('visibility', 'hidden');

    let image = $(document).find('.slider-for .slick-current.slick-active .image-type-slide');

    imageLoaded( image.attr('src') )

    .then((imgSrc) => {

        image.width(''), image.height('')

        let ratio = image.width() / image.height();

        let wrapperRatio = $('.slider-for .slick-current.slick-active .wrapper').width() / $('.slider-for .slick-current.slick-active .wrapper').height();

        if (wrapperRatio < 1) {

            if ($('.slider-for .slick-current.slick-active .image-type-slide').width() > $('.slider-for .slick-current.slick-active .wrapper').width()) {
                let newRatio = $('.slider-for .slick-current.slick-active .wrapper').width() / $('.slider-for .slick-current.slick-active .image-type-slide').width();
                image.height(image.height() * newRatio);
                image.width($('.slider-for .slick-current.slick-active .wrapper').width());
            }

            else if ($('.slider-for .slick-current.slick-active .image-type-slide').width() < $('.slider-for .slick-current.slick-active .wrapper').width() || $('.slider-for .slick-current.slick-active .image-type-slide').height() > $('.slider-for .slick-current.slick-active .wrapper').height()) {

                if($('.slider-for .slick-current.slick-active .image-type-slide').width() > $('.slider-for .slick-current.slick-active .image-type-slide').height()){
                    $('.slider-for .slick-current.slick-active .image-type-slide').height($('.slider-for .slick-current.slick-active .wrapper').width() / ratio);
                    $('.slider-for .slick-current.slick-active .wrapper').scrollTop(($('.slider-for .slick-current.slick-active .image-type-slide').height() - $('.slider-for .slick-current.slick-active .wrapper').height()) / 2);
                } else {
                    $('.slider-for .slick-current.slick-active .image-type-slide').height($('.slider-for .slick-current.slick-active .wrapper').height());
                    $('.slider-for .slick-current.slick-active .image-type-slide').width($('.slider-for .slick-current.slick-active .wrapper').width());
                }
            }

            let marginTop;

            if(image.width() > image.height()){
                marginTop = ( $('.slider-for .slick-current.slick-active .wrapper').height() - $('.slider-for .slick-current.slick-active .image-type-slide').height() ) / 2;
            } else {
                marginTop = 0;
            }

            $('.slider-for .slick-current.slick-active .image-wrapper').css({'margin-top' : marginTop});

        } else {

            $('.slider-for .slick-current.slick-active .image-wrapper').css({'height' : '100%'});
            $('.image-type-slide').css({'height' : $('.slider-for .slick-current.slick-active .wrapper').height() + 'px' })
            $('.image-type-slide').css({'width' : 'auto'})
        }

        $('.image-wrapper .pin').hide();

        $('.slider-for .slick-current.slick-active .image-wrapper .pin').show();

        $('.slider-for .slick-current.slick-active .image-wrapper img.image-type-slide').css({
            'visibility' : 'initial',
            'display' : 'table'
        });

    })

    .catch(err => console.log(err))

};

const imageLoaded = function(src) {

    return new Promise((resolve, reject) => {

      const image = new Image()

      image.onload = () => {
        resolve(src)
      }

      image.onerror = (error) => {
        reject(error)
      }

      image.src = src

    })

};

const zoomIn = function(isDesktop) {

    let step = isDesktop ? me.zoomStep : me.zoomStepMobile
    let wrapperRatio = $('.slick-active .wrapper').width() / $('.slick-active .wrapper').height();
    let ratio = $('.slick-active .image-type-slide').width() / $('.slick-active .image-type-slide').height();
    let newHeight = $('.slick-active .image-type-slide').height() + step;

    //behöver även max zoom med i denna spärren
    if (wrapperRatio < 1) {

        if ($('.slick-active .wrapper').width() * me.maxZoom > $('.slick-active .image-type-slide').width() && $('.slick-active .wrapper').height() * me.maxZoom > $('.slick-active .image-type-slide').height()) {
            $('.slick-active .image-type-slide').height(newHeight);
            $('.slick-active .image-type-slide').width($('.slick-active .image-type-slide').width() + step * ratio);

            let marginTop;
            if($('.slick-active .image-type-slide').height() < $('.slick-active .wrapper').height()){
                marginTop = (( $('.slick-active .wrapper').height() - $('.slick-active .image-type-slide').height() ) / 2);
            } else {
                marginTop = 0;
            }

            $('.slick-active .image-wrapper').css({'margin-top' : marginTop});
            // Reposition image while zooming
            $('.slick-active .wrapper').scrollTop($('.slick-active .wrapper').scrollTop() + step / 2);
            $('.slick-active .wrapper').scrollLeft($('.slick-active .wrapper').scrollLeft() + step * ratio / 2);
        }
    }
    else {
        if ($('.slick-active .wrapper').width() * me.maxZoom > $('.slick-active .image-type-slide').width() && $('.slick-active .wrapper').height() * me.maxZoom > $('.slick-active .image-type-slide').height()) {
            // Now we can increase image-type-slide size
            $('.slick-active .image-type-slide').height(newHeight);
            // Reposition image while zooming
            $('.slick-active .wrapper').scrollTop($('.slick-active .wrapper').scrollTop() + step / 2);
            $('.slick-active .wrapper').scrollLeft($('.slick-active .wrapper').scrollLeft() + step * ratio / 2);

            $('.slick-active .image-wrapper').css({
                'height' : 'initial',
            });
        }

    }

    if(dataStore.viewActive.heatmap) {

        dataStore.heatMapDataPointsTimoutDebounce = setTimeout(() => {
            createHeatMapsImages(dataStore.currentSlide, dataStore.collectedAnswers);
        }, 500)
    }
};

const createHeatMapsImages = function(item, incomingAnswers) {

    if(item.type === 'image') {

        $('.heatmap-canvas').remove()

        let image = $(`.slide-item-${item.id} .image-type-slide`);

        let width = image.width();
        
        let height = image.height();

        const answers = incomingAnswers;

        dataStore.heatMapDataPoints[item.id] = {

            answers : answers.map(answer => {
                return {
                    x: parseInt(width * (answer.lng / 100)),
                    y: parseInt(height * (answer.lat / 100)),
                }
            }),

            height : height,
            width : width
        }

        let dataPoints = dataStore.heatMapDataPoints[item.id].answers;

        let wrapper = document.querySelector(`.slide-item-${item.id} .image-wrapper`);

        let config = {
            container: wrapper,
            radius: 30,
            maxOpacity: .5,
            minOpacity: 0,
            blur: .75,
        };

        if(dataPoints && dataPoints.length  ) {
            // https://www.patrick-wied.at/static/heatmapjs/docs.html
            var heatmapInstance = heatmap.create(config);

            heatmapInstance.setData({
                max: 1,
                data: dataPoints
            });

            dataStore.heatMapDataPoints[item.id].instance = heatmapInstance;
        }

    }
};

const zoomOut = function(isDesktop) {

    let step = isDesktop ? me.zoomStep : me.zoomStepMobile
    let wrapperRatio = $('.slick-active .wrapper').width() / $('.slick-active .wrapper').height();
    let ratio = $('.slick-active .image-type-slide').width() / $('.slick-active .image-type-slide').height();

    if (wrapperRatio < 1 && $('.slick-active .image-type-slide').width() > $('.slick-active .wrapper').width()) {

        $('.slick-active .image-type-slide').height($('.slick-active .image-type-slide').height() - step);
        $('.slick-active .image-type-slide').width($('.slick-active .image-type-slide').width() - step * ratio);

        let marginTop;

        if($('.slick-active .image-type-slide').height() < $('.slick-active .wrapper').height()){
            marginTop = (( $('.slick-active .wrapper').height() - $('.slick-active .image-type-slide').height() ) / 2);
        } else {
            marginTop = 0;
        }

        $('.slick-active .image-wrapper').css({'margin-top' : marginTop});
        // Reposition image while zooming
        $('.slick-active .wrapper').scrollTop($('.slick-active .wrapper').scrollTop() - step / 2);
        $('.slick-active .wrapper').scrollLeft($('.slick-active .wrapper').scrollLeft() - step * ratio / 2);

    }

    else if(wrapperRatio < 1 && $('.slick-active .image-type-slide').width() < $('.slick-active .wrapper').width()) {

        if($('.slick-active .image-type-slide').width() > $('.slick-active .image-type-slide').height()){
            $('.slick-active .image-type-slide').css({'height' : 'initial'});
        } else {
            $('.slick-active .image-type-slide').height($('.slick-active .wrapper').height());
        }
        $('.slick-active .image-type-slide').width($('.slick-active .wrapper').width());
    }

    else {

        if($('.slick-active .image-type-slide').height() - step > $('.slick-active .wrapper').height()){

            $('.slick-active .image-type-slide').height($('.slick-active .image-type-slide').height() - step);

            $('.slick-active .image-wrapper').css({
                'height' : 'initial'
            });

            $('.slick-active .wrapper').scrollTop($('.slick-active .wrapper').scrollTop() - step / 2);
            $('.slick-active .wrapper').scrollLeft($('.slick-active .wrapper').scrollLeft() - step * ratio / 2);
        }

        else {

            if($('.slick-active .wrapper').width() > $('.slick-active .wrapper').height()){
                $('.slick-active .image-type-slide').height($('.slick-active .wrapper').height());
            }
        }
    }

    if(dataStore.viewActive.heatmap) {

        dataStore.heatMapDataPointsTimoutDebounce = setTimeout(() => {
            createHeatMapsImages(dataStore.currentSlide, dataStore.collectedAnswers);
        }, 500)
    }

};

const getImageSrc = function( src, size = '' ) {

    const parts = src.split('.')

    if( size === 'thumbnail' ) {
        src = parts[0] + '_thumbnail.' + parts[1]
    }

    if( size === 'scaled' ) {
        src = parts[0] + '_scaled.' + parts[1]
    }

    return src
}

export {
    repositionImage,
    zoomIn,
    zoomOut,
    createHeatMapsImages,
    getImageSrc
}
